<template>
<el-dialog :title="viewFlag === 'view' ? '查看' :  !dataForm.id ? '新增' : '修改'" :close-on-click-modal="false" width="60%" :visible.sync="viewData.visible">
    <el-form :model="dataForm" ref="dataForm" @keyup.enter.native="dataFormSubmit()" label-width="0px" class="org-dialog-form">
        <el-tabs>
            <el-tab-pane key="1" label="基础信息">
                <div class="des_box">
                    <el-descriptions class="margin-top" :column="2" size="small" border style="margin-bottom: 15px;">
                        <el-descriptions-item label="32位唯一标识:" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item prop="zguid" style="margin-bottom: 0" size="small">
                                <span v-if="viewFlag === 'view'">{{dataForm.zguid}}</span>
                                <el-input v-else v-model="dataForm.zguid" placeholder="32位唯一标识" clearable></el-input>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="SRM协议号:" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item prop="zsrmh" style="margin-bottom: 0" size="small">
                                <span v-if="viewFlag === 'view'">{{dataForm.zsrmh}}</span>
                                <el-input v-else v-model="dataForm.zsrmh" placeholder="SRM协议号" clearable></el-input>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="OPTION:" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item prop="choose" style="margin-bottom: 0" size="small">
                                <span v-if="viewFlag === 'view'">{{dataForm.choose}}</span>
                                <el-select v-else v-model="dataForm.choose" placeholder="请选择">
                                    <el-option v-for="item in CHOOSE_TYPE" :key="item.value" :label="item.label" :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="供应商帐户号:" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item prop="lifnr" style="margin-bottom: 0" size="small">
                                <span v-if="viewFlag === 'view'">{{dataForm.lifnr}}</span>
                                <el-input v-else v-model="dataForm.lifnr" placeholder="供应商帐户号" clearable></el-input>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="工厂:" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item prop="werks" style="margin-bottom: 0" size="small">
                                <span v-if="viewFlag === 'view'">{{dataForm.werks}}</span>
                                <el-select v-else v-model="dataForm.werks" filterable placeholder="请选择工厂">
                                    <el-option v-for="item in factoryList" :key="item.factoryCode" :label="item.factoryDesc" :value="item.factoryCode">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="物料号:" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item prop="matnr" style="margin-bottom: 0" size="small">
                                <span v-if="viewFlag === 'view'">{{dataForm.matnr}}</span>
                                <el-input v-else v-model="dataForm.matnr" placeholder="物料号" clearable></el-input>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="采购组:" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item prop="ekgrp" style="margin-bottom: 0" size="small">
                                <span v-if="viewFlag === 'view'">{{dataForm.ekgrp}}</span>
                                <el-input v-else v-model="dataForm.ekgrp" placeholder="采购组"></el-input>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="采购组织:" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item prop="ekorg" style="margin-bottom: 0" size="small">
                                <span v-if="viewFlag === 'view'">{{dataForm.ekorg}}</span>
                                <el-select v-else v-model="dataForm.ekorg" filterable placeholder="请选择组织">
                                    <el-option v-for="item in purchaseOrgList" :key="item.purchaseOrgCode" :label="item.purchaseOrgName" :value="item.purchaseOrgCode">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-descriptions-item>
                    </el-descriptions>
                </div>
            </el-tab-pane>
            <el-tab-pane :key="2" label="附件文件">
                <!-- TODO:上传下载 产看 需求文档 -->
                <FilesUpDown ref="FilesUpDown" :bizId="dataForm.id" :bizType="FILE_BIZ_TYPE"></FilesUpDown>
            </el-tab-pane>
        </el-tabs>
    </el-form>
    <el-row :gutter="40">
        <el-col :span="24" style="text-align:right;">
            <el-button size="small" @click="viewData.visible = false">
                取消
            </el-button>
            <el-button v-if="viewFlag !== 'view'" size="small" type="primary" @click="dataFormSubmit()">
                保存
            </el-button>
        </el-col>
    </el-row>
</el-dialog>
</template>

<script>
import {
    getPurchaseRouteById,
    editPurchaseRoute,
    createPurchaseRoute,
    getPurchaseOrgList,
    getFactoryList
} from '@/controller/systemData'
import { 
    CHOOSE_TYPE,
    getChooseByValue,
} from "@/utils/const";
import moment from 'moment'
import FilesUpDown from "@/views/common/file-up-down";
// require('@/mock/mockContract');
export default {
    data() {
        return {
            FILE_BIZ_TYPE: 7,
            viewFlag : '',
            viewData: {
                visible: false,
                width: ''
            },
            CHOOSE_TYPE : CHOOSE_TYPE,
            getChooseByValue : getChooseByValue,
            purchaseOrgList: [],
            factoryList: [],
            dataList: [],
            dataForm: {
                zguid: '',
                zsrmh: '',
                choose: '',
                lifnr: '',
                werks: '',
                matnr: '',
                ekgrp: '',
                ekorg: '',
            },
        }
    },
    components: {
        FilesUpDown //上传附件
    },
    mounted() {},
    methods: {
        init(data, id, viewFlag) {
            console.log(id)
            // this.dataForm = data ? data : this.dataForm
            this.viewFlag = viewFlag
            this.dataForm.id = id || 0
            this.viewData.visible = true
            this.$nextTick(() => {
                //初始化上传附件
                this.$refs.FilesUpDown.init(id, this.FILE_BIZ_TYPE, null);
                this.$refs['dataForm'].resetFields()
                if (this.dataForm && this.dataForm.id) {
                    getPurchaseRouteById({}, this.dataForm.id).then(data => {
                        console.log(data)
                        if (data && data.code === '00') {
                            this.dataForm.zguid = data.body.zguid;
                            this.dataForm.zsrmh = data.body.zsrmh;
                            this.dataForm.choose = data.body.choose;
                            this.dataForm.lifnr = data.body.lifnr;
                            this.dataForm.werks = data.body.werks;
                            this.dataForm.matnr = data.body.matnr;
                            this.dataForm.ekgrp = data.body.ekgrp;
                            this.dataForm.ekorg = data.body.ekorg;
                        }
                    })
                }
                // 工厂
                this.getFactoryList()
                // 采购组织
                this.getPurchaseOrgList()
            })
        },
        // 下拉输入工厂
        getFactoryList() {
            getFactoryList({
                factoryCode: "",
                factoryDesc: "",
                address: "",
                post: "",
            }).then(data => {
                if (data && data.code === '00') {
                    this.factoryList = data.body;
                }
            });
        },
        // 下拉输入采购组织
        getPurchaseOrgList() {
            getPurchaseOrgList({
                purchaseOrgCode: "",
                purchaseOrgName: "",
            }).then(data => {
                if (data && data.code === '00') {
                    this.purchaseOrgList = data.body;
                }
            });
        },
        // OPTION(C 新建/U修改)
        chooseTypeFormat: function (value) {
            if (!value) {
                return "";
            }
            return getChooseByValue(CHOOSE_TYPE, value);
        },
        // 表单提交
        dataFormSubmit() {
            this.$refs['dataForm'].validate((valid) => {
                if (valid) {
                    let params = {
                        'id': this.dataForm.id || undefined,
                        'zguid': this.dataForm.zguid,
                        'zsrmh': this.dataForm.zsrmh,
                        'choose': this.dataForm.choose,
                        'lifnr': this.dataForm.lifnr,
                        'werks': this.dataForm.werks,
                        'matnr': this.dataForm.matnr,
                        'ekgrp': this.dataForm.ekgrp,
                        'ekorg': this.dataForm.ekorg,
                    }
                    if (this.dataForm.id) {
                        editPurchaseRoute(params).then(data => {
                            if (data && data.code === '00') {
                                this.$message({
                                    message: '操作成功',
                                    type: 'success',
                                    onClose: () => {
                                        this.viewData.visible = false
                                        this.$emit('refreshDataList')
                                    }
                                })
                            } else {
                                this.$message.error(data.msg)
                            }
                        })
                    } else {
                        createPurchaseRoute(params).then(data => {
                            if (data && data.code === '00') {
                                this.$message({
                                    message: '操作成功',
                                    type: 'success',
                                    onClose: () => {
                                        this.viewData.visible = false
                                        this.$emit('refreshDataList')
                                    }
                                })
                            } else {
                                this.$message.error(data.msg)
                            }
                        })
                    }
                }
            })
        },
        getStyle() {
            return 'width: 110px; text-align: right'
        },
        getStyle2() {
            return 'width: 314.4px;'
        }
    }
}
</script>

<style lang="scss" scoped>
.el-dialog__body {
    .org-dialog-form {
        width: 100%;
    }
}

.linetext {
    white-space: pre-line;
}
</style>
